<template>
  <div class="handle-open">
    <div class="close-open" @click="closeWindow"><i class="el-icon-close"></i></div>
    <div class="title-top-alarm" v-if="alarmtype !== 'phonein'">
      <div><span>事件处理</span></div>
      <div class="line-title"></div>
    </div>
    <div v-if="!isNoOldPerson"> <!--有服务对象信息-->
      <div style="height: 40px;margin: 0 70px">
        <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
          <span>{{item.name}}</span>
        </div>
      </div>
      <!--        固定个人信息-->
      <div>
        <div>
          <call-phone-out v-if="phone1 && phone2 && phone3" :phoneOut="callPhone" @fatherEvent="fatherEvent"></call-phone-out>
        </div>
        <div style="height: 40px;text-align: center;font-size: 18px" v-if="isNoOldPerson11">
          <span>该家庭下暂无服务对象，请新建服务对象。</span>
          <el-button size="mini" icon="el-icon-plus" type="success" @click="isNoOldPerson = true">新 建</el-button>
        </div>
        <div style="margin: 10px 70px;font-size: 16px;color: #808080">
          <el-row style="margin-top: 15px" v-if="handleAlarmRow.alarmOrder && handleAlarmRow.alarmOrder !== ''">
            <el-col :span="12">转让人：<span class="span-color">{{handleAlarmRow.alarmOrder.fromname}}</span></el-col>
            <el-col :span="12">接收人：<span class="span-color">{{handleAlarmRow.alarmOrder.toname}}</span></el-col>
          </el-row>
          <el-row style="margin-top: 15px">
            <el-col :span="12">事件时间：<span class="span-color">{{time}}</span></el-col>
            <el-col :span="12">事件类型：
              <img style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImgAlarm(alarmtype)">
              <span class="span-color">
              {{getAType()}}
            </span></el-col>
          </el-row>
          <el-row style="margin-top: 15px" v-if="alarmtype !== 'phonein'">
            <el-col :span="12">设备编号：<span class="span-color">{{deviceid}}</span></el-col>
            <el-col :span="12">设备类型：
              <span class="span-color" v-if="handleAlarmRow.row.device">{{getDeviceType(devicetype)}}</span>&nbsp;&nbsp;
              <img v-if="handleAlarmRow.row.device && (handleAlarmRow.row.device.devicetype === 300 || handleAlarmRow.row.device.devicetype === 350) && handleAlarmRow.row.lng !== 0 && handleAlarmRow.row.lat !== 0"
                   style="vertical-align: sub;width: 20px;height: 20px;cursor: pointer"
                   src="/static/tableIcon/icon_location.png"
                   @click="openMapLocation">
              <img v-if="handleAlarmRow.row.device && handleAlarmRow.row.device.devicetype === 700 && homeObj.home.lng !== 0 && homeObj.home.lat !== 0"
                   style="vertical-align: sub;width: 20px;height: 20px;cursor: pointer"
                   src="/static/tableIcon/icon_location.png"
                   @click="openMapLocation">
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px" v-if="alarmtype !== 'phonein' && handleAlarmRow.row.device && (handleAlarmRow.row.device.devicetype === 700 || handleAlarmRow.row.device.devicetype === 504)">
            <el-col :span="24">设备标识：<span>{{h_install_location}}</span>
            </el-col>
          </el-row>
          <div v-if="indexActive !== 1">
            <el-row style="margin-top: 15px">
              <el-col :span="12">服务对象：<span class="span-color">{{p_name}}</span></el-col>
              <el-col :span="12">性别：<span class="span-color">{{p_sex}}</span></el-col>
            </el-row>
            <el-row style="margin-top: 15px">
              <el-col :span="12">出生日期：<span class="span-color">{{p_birthday}}</span></el-col>
              <el-col :span="12">所属项目：<span class="span-color">{{p_project}}
            </span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 15px" v-if="indexActive !== 2">
              <el-col :span="12" class="all-three-point" :title="orglevelname">所属区域：<span class="span-color">{{orglevelname}}</span></el-col>
              <el-col :span="12" class="all-three-point" :title="h_address">家庭地址：<span class="span-color">{{h_address}}</span></el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div v-if="indexActive === 0">
        <div style="height: 5px"></div>
        <div style="height: 1px;background-color: #ebebeb;"></div>
        <div style="margin: 10px 70px;font-size: 16px;color: #808080">
          <el-row style="margin-top: 15px">
            <el-col :span="12">
              <div style="float:left;">
                事件状态：<span class="span-color">已处理</span>
                <span class="span-font">{{prehandle}}</span><span class="span-color">次</span>
              </div>
              <div class="history-handle" v-if="prehandle > 0" @click="openHistoryLog()">
                <span>查看历史处理</span>
              </div>
              <div style="clear:both;"></div>
            </el-col>
            <el-col :span="12" v-if="isShanghai">
              <div style="float: left;width: 80px;line-height: 40px">
                <span style="color: red">*</span>派&nbsp;&nbsp;&nbsp;&nbsp;单：
              </div>
              <div style="float: left;width: calc(100% - 80px)">
                <el-cascader v-fixZoom style="width: 100%" v-model="showid" placeholder="请选择" :options="typeEndTree" :props="propType"
                             filterable change-on-select clearable ref="stidData" @change="getStidImgNew">
                  <template #default="{data}">
                    <span v-if="data.noSelect" style="font-style: italic;color: #999999">{{ data.showName}}</span><strong v-else style="color: #1a1a1a;">{{ data.showName}}</strong>
                  </template>
                </el-cascader>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="float: left;width: 90px;line-height: 40px">
                <span style="color: red">*</span>处理类型：
              </div>
              <div style="float: left;width: calc(100% - 90px);line-height: 40px">
                <el-radio-group v-model="alarmRadio">
                  <el-radio label="1">已处理</el-radio>
                  <el-radio label="2">误报</el-radio>
                  <el-radio label="3">派单</el-radio>
                </el-radio-group>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px" v-if="isShanghai">
            <el-col :span="24">
              <div style="float: left;width: 80px;line-height: 40px"><span style="color: red">*</span>备&nbsp;&nbsp;&nbsp;&nbsp;注：</div>
              <div style="float: left;width: calc(100% - 80px)">
                <el-input style="width: 100%" placeholder="请输入事件处理备注" v-model="handleMessage"></el-input>
              </div>
              <div style="clear: both"></div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px" v-else>
            <el-col :span="12">
              <div style="float: left;width: 80px;line-height: 40px"><span style="color: red" v-if="this.isShanghai">*</span>备&nbsp;&nbsp;&nbsp;&nbsp;注：</div>
              <div style="float: left;width: calc(100% - 100px)">
                <el-input style="width: 100%" placeholder="请输入事件处理备注" v-model="handleMessage"></el-input>
              </div>
              <div style="clear: both"></div>
            </el-col>
            <el-col :span="12" v-if="alarmRadio === '3'">
              <div style="float: left;width: 90px;line-height: 40px">
                <span style="color: red">*</span>派&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;单：
              </div>
              <div style="float: left;width: calc(100% - 90px)">
                <el-cascader v-fixZoom style="width: 100%" v-model="showid" placeholder="请选择" :options="typeEndTree" :props="propType"
                             filterable change-on-select clearable ref="stidData" @change="getStidImgNew">
                  <template #default="{data}">
                    <span v-if="data.noSelect" style="font-style: italic;color: #999999">{{ data.showName}}</span><strong v-else style="color: #1a1a1a;">{{ data.showName}}</strong>
                  </template>
                </el-cascader>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if="isFive" style="margin: 0 20px;">
          <history-log :logObj="logObj"></history-log>
        </div>
        <div style="margin-top: 20px;height:50px;text-align: right">
          <el-row>
            <el-col :span="6">
              <div class="send-btn" @click="addHandleList()"><span>加入列表处理</span></div>
            </el-col>
            <el-col :span="6">
              <div style="height: 30px;width: 200px;margin: auto">
                <div class="send-btn-yellow"><span>{{selectName}}</span></div>
                <div class="send-btn-yellow1" @click="openListCsd()">
                  <i v-if="selectShow" class="el-icon-caret-top"></i>
                  <i v-else class="el-icon-caret-bottom"></i>
                </div>
              </div>
              <div v-if="selectShow" class="list-csd">
                <div class="left-level1">
                  <div v-for="item in customerLevelTag1" :key="item.index" class="all-line" @mouseover="changeTag(item)"
                       :class="level1 === item.customerservicetag ? 'level-line1-active' : 'level-line1'">
                    &nbsp;<span>{{item.nameShow}}</span>
                    <i style="margin-left: 50px" class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="left-level2">
                  <div class="list-csd-item" v-if="customerServiceTag.length === 0" style="text-align: center"><span>暂无数据</span></div>
                  <div class="list-csd-item" v-for="item in customerServiceTag" :key="item.index" @click="selectTags(item)">
                    <span>{{item.nameShow}}</span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="send-btn" @click="handleServiceCommit()"><span>派单服务</span></div>
            </el-col>
            <el-col :span="6">
              <div class="send-btn-green" @click="handleCommit()"><span>结单处理</span></div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--服务对象信息-->
      <div v-if="indexActive === 1">
        <service-object-alarm :serviceObj="serviceObj" @handleAlarm="getPersonNew"></service-object-alarm>
        <div style="height: 20px"></div>
      </div>
      <!--家庭信息-->
      <div v-if="indexActive === 2">
        <home-details :homeObj="homeObj" @handleAlarmHome="getHomeChange"></home-details>
        <div style="height: 20px"></div>
      </div>
      <!--服务日志-->
      <div v-if="indexActive === 3" style="margin: 0 40px">
        <history-log :logObj="logObj"></history-log>
      </div>
      <!--设备详情-->
      <div v-if="indexActive === 4" style="margin: 0 40px">
        <device-details :deviceObj="deviceObj"></device-details>
      </div>
    </div>
    <!--新建服务信息-->
    <div v-else>
      <old-person ref="oldPerson" :personObj="personObj" @getFather="getFather"></old-person>
    </div>
    <el-dialog width="650px" :visible.sync="showHistory" v-if="showHistory" :close-on-click-modal="false" append-to-body class="all-open">
      <div class="title-top-alarm">
        <div><span>历史处理</span></div>
        <div class="line-title"></div>
      </div>
      <history-handle :handleHistoryObj="handleHistoryObj" v-model="showHistory"></history-handle>
    </el-dialog>
    <el-dialog width="900px" :visible.sync="showLoaction" v-if="showLoaction" :close-on-click-modal="true" append-to-body class="all-open">
      <div class="title-top-alarm">
        <div><span>位置详情</span></div>
        <div class="line-title"></div>
      </div>
      <div style="height: 620px">
        <track-details :trackDetailsObj="handleMapObj"></track-details>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {hanlealarm, queryoldpersonbypids, queryoldpersonbyhids, queryhomebyhids, queryphonebypid, queryphonebyhid, prehanlealarm, appointhanlealarm, queryorgpersonuser} from '../../../api/handlealarm'
import {sendSub} from '../../../mq'
import serviceObjectAlarm from '../../handlealarm/childComponents/serviceObjectAlarm'
import homeDetails from '../../statisticalform/childComponents/homeDetails'
import historyLog from '../quick/components/historyLog'
import callPhoneOut from '../../handlealarm/childComponents/callPhoneOut'
import historyHandle from './historyHandle'
import oldPerson from '../quick/components/oldPerson'
import mapLocation from '../../handlealarm/childComponents/mapLocation'
import deviceDetails from '../quick/components/deviceDetails'
import trackDetails from '../deviceComponents/trackDetails'
import {queryorg} from '../../../api/organizer'
export default {
  name: 'doHandleAlarm',
  components: { serviceObjectAlarm, homeDetails, historyLog, callPhoneOut, historyHandle, oldPerson, mapLocation, deviceDetails, trackDetails },
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    handleAlarmRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [{index: 0, name: '事件详情'}, {index: 1, name: '服务对象信息'}, {index: 2, name: '家庭信息'}, {index: 3, name: '服务日志'}, {index: 4, name: '设备详情'}],
      indexActive: 0,
      // typeOrg: [],
      // supplierorg: [],
      projects: [],
      oldpersons: [],
      orghomes: [],
      // 开始
      time: '',
      alarmtype: '',
      p_name: '',
      p_birthday: '',
      p_sex: '',
      p_project: '',
      deviceid: '',
      devicetype: '',
      h_install_location: '',
      orglevelname: '',
      h_address: '',
      prehandle: 0,
      // 结束
      imgIconAlarm: [],
      alarmid: '',
      phone1: false, // 人员电话
      phone2: false, // 家庭电话
      phone3: false, // 设备电话
      callPhone: {
        isAlarm: true,
        callPhoneObj: {},
        device_person: [], // 个人手表设备号码
        device_home: [], // 家庭网关设备号码
        person: [], // 个人号码/个人其它号码
        home: [], // 家庭号码/固话
        familyperson: [], // 家庭亲戚/联系人号码
        oldperson: ''
      },
      // 派单新
      types: [], // 服务类型
      supplierorgNew: [], // 服务商
      serviceData: [], // 服务内容
      orgData: [], // 组织
      showid: '',
      propType: { checkStrictly: true, value: 'showId', label: 'showName', children: 'child', emitPath: false, disabled: 'noSelect' },
      typeEndTree: [],
      allType: [],
      stid: '',
      soid: '',
      newTypes: [],
      options: [],
      props1: { checkStrictly: true, value: 'id', label: 'showname', children: 'child', emitPath: false },
      handleMessage: '',
      // 服务对象
      serviceObj: {
        projects: [],
        frequencys: [],
        oldperson: '',
        editOldPerson: '', // 话务客服权限可编辑服务对象信息
        isEdit: true // 话务客服权限可修改服务对象信息跟家庭信息
      },
      hids: [],
      pids: [],
      homeObj: {
        home: '',
        orgcommunitys: [],
        oldpersons: [], // 家庭联系人
        isEdit: true // 话务客服权限可修改服务对象信息跟家庭信息
      },
      sex: '',
      isFive: false,
      logObj: {
        isFive: true,
        personids: []
      },
      phonepids: [],
      phonehids: [],
      selectShow: false,
      // 指定客服处理
      level1: 1,
      customerLevelTag1: [
        {customerservicetag: 1, nameShow: '话务客服'},
        {customerservicetag: 2, nameShow: '计生律师'},
        {customerservicetag: 3, nameShow: '外勤客服'}
      ],
      allCustomer: [],
      // 指定客服处理 二级
      customerServiceTag: [],
      selectName: '订单转让',
      showHistory: false,
      handleHistoryObj: {
        alarmRow: ''
      },
      isNoOldPerson11: false,
      isNoOldPerson: false, // 请求服务对象返回空需要走新建服务对象流程
      personObj: {
        homeObj: '', // 家的信息
        phone: '111', // 判断是否是从处理事件而创建服务对象 显示下一步按钮
        orgcommunitys: [],
        orgOptions: [],
        frequencys: [],
        projects: [],
        isAddPerson: true, // 是否是新建服务对象
        isDoAdd: false, // 完成新建服务对象之后再修改
        editRow: {},
        addData: {} // 添加完成之后的表单信息
      },
      showLoaction: false,
      handleMapObj: {
        type: 'alarm',
        alarmRow: '',
        person: '',
        device: ''
      },
      deviceObj: { // 设备详情
        personId: '',
        hid: ''
      },
      isShanghai: false,
      alarmRadio: ''
    }
  },
  created () {
    if (window.location.host === 'newjky.wecare-u.net' || window.location.host === 'newhealth.wecare-u.net' ||
      window.location.host === 'kangnh.com' || window.location.host === 'bengshan.kangnh.com') { // 上海更换
      this.isShanghai = true
    }
    /* 1、handleAlarm.vue 事件处理 页面 2、phoneInAlarm.vue 电话呼入弹窗 */
    console.log('handleAlarmRow', this.handleAlarmRow)
    this.imgIconAlarm = this.getImgArr.getImgIconAlarm()
    // handleAlarmRow: {frequencys：服务频率，isPhonein：是否是电话呼入，oldPerson：电话呼入选择人的信息，orgcommunitys：小区信息
    // projects：项目信息，row：表格每行信息，supplierorg：服务商信息，typeOrg types
    this.types = this.handleAlarmRow.types
    this.projects = this.handleAlarmRow.projects
    this.supplierorgNew = this.handleAlarmRow.supplierorg
    this.serviceData = this.handleAlarmRow.typeOrg
    this.getCsd()
    this.getOrgData() // 递归派单
    this.getStartData()
  },
  mounted () {
  },
  methods: {
    getPersonNew (person) {
      this.serviceObj.editOldPerson = person
    },
    getHomeChange (home) {
      this.homeObj.home = home
    },
    closeWindow () {
      let mqtts = this.$store.state.user.mqtts
      let name = this.$store.state.user.personname
      let jobnum = this.$store.state.user.syspersonjobnum
      let dohandle = {id: this.alarmid, name: name, jobnum: jobnum}
      sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
      this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
        if (this.$route.path === '/handleAlarm') {
          this.golobleObject.updateTableAlarm()
        }
      })
      let obj = {type: 'close'}
      this.$emit('getFatherHandle', obj)
    },
    getStartData () {
      this.deviceObj.hid = this.handleAlarmRow.row.h_hid !== 0 ? this.handleAlarmRow.row.h_hid : ''
      this.deviceObj.personId = this.handleAlarmRow.row.p_pid !== 0 ? this.handleAlarmRow.row.p_pid : ''
      this.alarmid = this.handleAlarmRow.row.id
      this.handleHistoryObj.alarmRow = this.handleAlarmRow.row
      if (this.handleAlarmRow.isPhonein) { // 电话呼入
        this.serviceObj.oldperson = this.handleAlarmRow.oldPerson
        this.serviceObj.editOldPerson = this.handleAlarmRow.oldPerson
        this.deviceObj.hid = this.serviceObj.oldperson.homeid
        this.callPhone.oldperson = this.handleAlarmRow.oldPerson
        this.phone3 = true
        this.logObj.personids.push(this.handleAlarmRow.oldPerson.id)

        this.time = this.handleAlarmRow.row.time
        this.alarmtype = this.handleAlarmRow.row.alarmtype
        this.p_name = this.handleAlarmRow.oldPerson.name
        this.p_birthday = this.handleAlarmRow.oldPerson.birthday
        this.getSex(this.handleAlarmRow.oldPerson.sex)
        this.p_project = this.getProjectName(this.handleAlarmRow.oldPerson.projectid)
        this.h_address = this.handleAlarmRow.oldPerson.h_address
        this.prehandle = this.handleAlarmRow.row.prehandle

        this.hids = [this.handleAlarmRow.oldPerson.homeid]
        if (this.handleAlarmRow.oldPerson.id !== 0) {
          this.phonepids.push(this.handleAlarmRow.oldPerson.id)
          this.getPhoneByPerson()
        } else {
          this.phone1 = true
        }
        if (this.handleAlarmRow.oldPerson.homeid !== 0) {
          this.phonehids.push(this.handleAlarmRow.oldPerson.homeid)
          this.getPhoneByHome()
        } else {
          this.phone2 = true
        }
        this.getHomeData() // 家信息
        this.getOldPersonByHome() // 家庭成员
      } else {
        if (this.handleAlarmRow.row.p_pid !== 0) {
          this.phonepids.push(this.handleAlarmRow.row.p_pid)
          this.getPhoneByPerson()
        } else {
          this.phone1 = true
        }
        if (this.handleAlarmRow.row.h_hid !== 0) {
          this.phonehids.push(this.handleAlarmRow.row.h_hid)
          this.getPhoneByHome()
        } else {
          this.phone2 = true
        }
        this.handleMapObj.alarmRow = this.clone(this.handleAlarmRow.row)
        // 其他报警
        this.time = this.handleAlarmRow.row.time
        this.alarmtype = this.handleAlarmRow.row.alarmtype
        this.p_name = this.handleAlarmRow.row.p_name
        // p_birthday p_sex p_project
        this.deviceid = this.handleAlarmRow.row.device ? this.handleAlarmRow.row.device.deviceid : ''
        this.devicetype = this.handleAlarmRow.row.device ? this.handleAlarmRow.row.device.devicetype : ''
        let aa = ''
        if (this.handleAlarmRow.row.sub_deviceid !== '' && this.handleAlarmRow.row.subdevice && this.handleAlarmRow.row.subdevice.remark !== '') {
          aa = this.handleAlarmRow.row.subdevice.remark
        } else {
          aa = this.handleAlarmRow.row.device ? this.handleAlarmRow.row.device.h_installlocation : ''
        }
        this.h_install_location = aa
        this.orglevelname = this.handleAlarmRow.row.homeObj ? this.handleAlarmRow.row.homeObj.orglevelname : ''
        this.h_address = this.handleAlarmRow.row.homeObj ? this.handleAlarmRow.row.homeObj.address : ''
        this.prehandle = this.handleAlarmRow.row.prehandle
      }
      this.serviceObj.frequencys = this.handleAlarmRow.frequencys
      this.serviceObj.projects = this.handleAlarmRow.projects
      this.homeObj.orgcommunitys = this.handleAlarmRow.orgcommunitys
      this.personObj.orgcommunitys = this.handleAlarmRow.orgcommunitys
      this.personObj.frequencys = this.handleAlarmRow.frequencys
      this.personObj.projects = this.handleAlarmRow.projects
      if (this.handleAlarmRow.row.device) {
        this.handleMapObj.device = this.handleAlarmRow.row.device
      }
      if (this.handleAlarmRow.row.p_pid !== 0) {
        this.pids = [this.handleAlarmRow.row.p_pid]
        this.getOldPerson() // 穿戴设备所绑定的人信息
      } else if (this.handleAlarmRow.row.h_hid !== 0) {
        this.hids = [this.handleAlarmRow.row.h_hid]
        this.getHomeData() // 家信息
        this.getOldPersonByHome() // 家庭成员
      }
    },
    // 获取普通客服
    getCsd () {
      let syspersonid = this.$store.state.user.syspersonid
      queryorgpersonuser().then(res => {
        let arr = res.data.orgpersons
        let list = []
        for (let i = 0; i < arr.length; i++) {
          if (syspersonid !== arr[i].id) {
            let obj = arr[i]
            obj.nameShow = arr[i].name + ' — ' + arr[i].jobnum
            list.push(obj)
            if (obj.customerservicetag === 1) {
              this.customerServiceTag.push(obj)
            }
          }
        }
        this.allCustomer = list
      }).catch(() => {})
    },
    // 获取电话按钮数据
    getPhoneByPerson () {
      let data = {
        pids: this.phonepids
      }
      queryphonebypid(data).then(res => {
        for (let i = 0; i < res.data.phones.length; i++) {
          if (res.data.phones[i].phonetype === 1) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 2) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 4 || res.data.phones[i].phonetype === 16) { // 个人号码  其他号码
            if (res.data.phones[i].phone) {
              this.callPhone.person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 8) {
            if (res.data.phones[i].phone) {
              this.callPhone.home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 32) {
            if (res.data.phones[i].phone) {
              this.callPhone.familyperson.push(res.data.phones[i])
            }
          }
        }
        this.phone1 = true
        console.log(this.phone1, this.phone2, this.phone3)
        console.log(this.callPhone)
      }).catch(() => {})
    },
    getPhoneByHome () {
      let data = {
        hids: this.phonehids
      }
      queryphonebyhid(data).then(res => {
        for (let i = 0; i < res.data.phones.length; i++) {
          if (res.data.phones[i].phonetype === 1) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 2) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 4 || res.data.phones[i].phonetype === 16) { // 个人号码  其他号码
            if (res.data.phones[i].phone) {
              this.callPhone.person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 8) {
            if (res.data.phones[i].phone) {
              this.callPhone.home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 32) {
            if (res.data.phones[i].phone) {
              this.callPhone.familyperson.push(res.data.phones[i])
            }
          }
        }
        this.phone2 = true
        console.log(this.phone1, this.phone2, this.phone3)
        console.log(this.callPhone)
      }).catch(() => {})
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    openHistoryLog () {
      this.showHistory = true
    },
    selectTab (item) {
      if (item.index === 3) {
        this.logObj.isFive = false
      } else {
        if (this.alarmtype === 'heartbeat') {
          this.isFive = true
          this.logObj.isFive = true
        } else {
          this.isFive = false
          this.logObj.isFive = false
        }
      }
      this.indexActive = item.index
    },
    // 家信息
    getHomeData () {
      let data = {
        hids: this.hids
      }
      queryhomebyhids(data).then(res => {
        if (res.data.homes.length > 0) {
          this.homeObj.home = res.data.homes[0]
          this.personObj.homeObj = res.data.homes[0]
          if (this.handleAlarmRow.row.device.devicetype === 700 || this.handleAlarmRow.row.device.devicetype === 504) {
            this.handleMapObj.alarmRow.lng = this.homeObj.home.lng
            this.handleMapObj.alarmRow.lat = this.homeObj.home.lat
          }
        }
      }).catch(() => {})
    },
    // 家庭查家庭成员 （服务对象信息 默认第一个）
    getOldPersonByHome () {
      let data = {
        hids: this.hids
      }
      queryoldpersonbyhids(data).then(res => {
        if (res.data.persons.length === 0) {
          this.isNoOldPerson11 = true // 无服务对象需要添加服务对象
        } else {
          if (this.handleAlarmRow.row.p_pid === 0) {
            this.serviceObj.oldperson = res.data.persons[0] // 网关 服务对象信息 默认家庭成员的第一个
            this.serviceObj.editOldPerson = res.data.persons[0] // 网关 服务对象信息 默认家庭成员的第一个
            this.deviceObj.hid = this.serviceObj.oldperson.homeid
            this.callPhone.oldperson = res.data.persons[0]
            this.p_name = res.data.persons[0].name
            this.p_birthday = res.data.persons[0].birthday
            this.getSex(res.data.persons[0].sex)
            this.p_project = this.getProjectName(res.data.persons[0].projectid)
            this.handleMapObj.person = res.data.persons[0]
            if (this.p_birthday === '') {
              this.p_birthday = res.data.persons[0].birthday
              this.getSex(res.data.persons[0].sex)
              this.p_project = this.getProjectName(res.data.persons[0].projectid)
            }
          }
          this.phone3 = true
        }
        this.homeObj.oldpersons = res.data.persons // 家庭详细中家庭成员
        this.logObj.personids = [] // 服务日志
        for (let i = 0; i < res.data.persons.length; i++) {
          this.logObj.personids.push(res.data.persons[i].id)
        }
        if (this.alarmtype === 'heartbeat') {
          // console.log(123)
          this.isFive = true
          this.logObj.isFive = true
        }
        console.log('888oldperson', this.serviceObj.oldperson)
      }).catch(() => {})
    },
    // 服务对象信息
    getOldPerson () {
      let data = {
        pids: this.pids
      }
      queryoldpersonbypids(data).then(res => {
        if (res.data.persons.length > 0) {
          this.handleMapObj.person = res.data.persons[0]
          this.serviceObj.oldperson = res.data.persons[0]
          this.serviceObj.editOldPerson = res.data.persons[0]
          this.deviceObj.hid = this.serviceObj.oldperson.homeid
          this.callPhone.oldperson = res.data.persons[0]
          this.phone3 = true
          this.hids = [this.serviceObj.oldperson.homeid]
          this.p_birthday = res.data.persons[0].birthday
          this.getSex(res.data.persons[0].sex)
          this.p_project = this.getProjectName(res.data.persons[0].projectid)
        }
        this.getHomeData()
        this.getOldPersonByHome()
      }).catch(() => {})
    },
    // 派单
    getOrgData () {
      queryorg().then(res => {
        this.orgData = res.data.org
        let obj = this.commonType.getNewPaidan(this.orgData, this.supplierorgNew, this.types, this.serviceData)
        this.typeEndTree = obj.tree
        this.allType = obj.allArr
      }).catch(() => {})
    },
    getFather (obj) { // 新建服务对象调用父级方法
      if (obj.type === 'handle') {
        this.serviceObj.oldperson = obj.addEditForm
        this.serviceObj.oldperson.id = obj.personid
        this.serviceObj.editOldPerson = obj.addEditForm
        this.serviceObj.editOldPerson.id = obj.personid
        this.p_name = obj.addEditForm.name
        this.p_birthday = obj.addEditForm.birthday
        this.getSex(this.serviceObj.oldperson.sex)
        this.p_project = this.getProjectName(obj.addEditForm.projectid)
        this.homeObj.oldpersons = [this.serviceObj.oldperson] // 家庭信息 表格数据
        this.logObj.personids = []
        this.logObj.personids.push(obj.personid)
        this.isNoOldPerson11 = false
        this.isNoOldPerson = false
        this.deviceObj.hid = this.serviceObj.oldperson.homeid
        this.callPhone.oldperson = this.serviceObj.oldperson
        this.phone3 = true
      }
    },
    fatherEvent (obj) {},
    getSex (sex) {
      this.p_sex = this.util.getSex(sex + '')
    },
    getProjectName (projectid) {
      for (let i = 0; i < this.projects.length; i++) {
        if (projectid === this.projects[i].id) {
          return this.projects[i].projectname
        }
      }
    },
    getTypeImgAlarm (type) {
      let num = this.commonType.getAlarmTypeIcon(type)
      return this.imgIconAlarm[num].imgUrl
    },
    getAType () {
      return this.commonType.getAlarmType(this.alarmtype)
    },
    // 派单
    getStidImgNew (showId) {
      this.allType.forEach(item => {
        if (item.showId === showId) {
          console.log(item.st_id, item.so_id)
          this.stid = item.st_id
          this.soid = item.so_id
        }
      })
    },
    openListCsd () {
      this.selectShow = !this.selectShow
    },
    addHandleList () { // 加入列表处理
      if (this.isNoOldPerson11) {
        this.$message.error('请先添加服务对象信息！')
        return
      }
      if (this.handleMessage === '') {
        this.$message.error('请输入事件处理备注')
        return
      }
      let data = {
        aid: this.alarmid,
        so_id: this.soid,
        st_id: this.stid,
        content: this.handleMessage,
        pid: this.serviceObj.oldperson.id,
        hid: this.hids[0]
      }
      if (this.stid === '') {
        data.so_id = 0
        data.st_id = 0
      }
      prehanlealarm(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功加入列表处理',
          type: 'success',
          duration: 2000
        })
        let mqtts = this.$store.state.user.mqtts
        let name = this.$store.state.user.personname
        let jobnum = this.$store.state.user.syspersonjobnum
        let dohandle = {id: this.alarmid, name: name, jobnum: jobnum}
        sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
        this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
          if (this.$route.path === '/handleAlarm') {
            this.golobleObject.updateTableAlarm()
          }
        })
        let obj = {type: 'close'}
        this.$emit('getFatherHandle', obj)
      }).catch(() => {})
    },
    changeTag (item) {
      let arr = this.allCustomer.filter((val) => {
        if (val.customerservicetag === item.customerservicetag || ((item.customerservicetag === 1 || item.customerservicetag === 3) && val.customerservicetag === 4)) {
          return true
        }
      })
      this.customerServiceTag = arr
      this.level1 = item.customerservicetag
      // console.log(99, arr)
    },
    selectTags (item) { // 客服转让
      if (this.isNoOldPerson11) {
        this.$message.error('请先添加服务对象信息！')
        return
      }
      let data = {
        aid: this.alarmid,
        so_id: this.soid,
        st_id: this.stid,
        content: this.handleMessage,
        customerservicetag: item.customerservicetag,
        pid: this.serviceObj.oldperson.id,
        hid: this.hids[0]
      }
      if (data.customerservicetag === 3) {
        if (this.handleMessage === '') {
          data.content = '转让事件给外勤客服' + item.name + '处理。'
        }
      } else if (data.customerservicetag === 2) {
        if (this.handleMessage === '') {
          data.content = '转让事件给计生协法律咨询处理。'
        }
      } else {
        if (this.handleMessage === '') {
          data.content = '转让事件给' + item.name + '处理。'
        }
      }
      if (this.stid === '') {
        data.so_id = 0
        data.st_id = 0
      }
      appointhanlealarm(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功指派客服处理',
          type: 'success',
          duration: 2000
        })
        let name = this.$store.state.user.personname
        let jobnum = this.$store.state.user.syspersonjobnum
        let dohandle = {id: this.alarmid, name: name, jobnum: jobnum}
        let syspersonid = this.$store.state.user.syspersonid
        // debugger
        if (data.customerservicetag === 1 || data.customerservicetag === 3) {
          let obj = {
            from: syspersonid,
            fromname: name,
            to: item.id,
            toname: item.name,
            alarmid: this.alarmid
          }
          let mqtt = '/csd/' + item.id
          sendSub(mqtt, JSON.stringify(obj))
        }
        let mqtts = this.$store.state.user.mqtts
        sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
        this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
          if (this.$route.path === '/handleAlarm') {
            this.golobleObject.updateTableAlarm()
          }
        })
        let obj = {type: 'close'}
        this.$emit('getFatherHandle', obj)
      }).catch(() => {})
    },
    handleCommit () { // 结单处理
      if (this.isNoOldPerson11) {
        this.$message.error('请先添加服务对象信息！')
        return
      }
      if (this.isShanghai) {
        if (this.stid === '') {
          this.$message.error('请选择派单')
          return
        }
        if (this.handleMessage === '') {
          this.$message.error('请输入事件处理备注')
          return
        }
      } else {
        if (this.alarmRadio === '') {
          this.$message.error('请选择处理类型')
          return
        } else if (this.alarmRadio === '3' && this.stid === '') {
          this.$message.error('请选择派单')
          return
        }
      }
      let data = {
        aid: this.alarmid,
        so_id: this.soid,
        st_id: this.stid,
        content: this.handleMessage,
        pid: this.serviceObj.oldperson.id,
        hid: this.hids[0]
      }
      if (!this.isShanghai) {
        if (this.alarmRadio === '1' || this.alarmRadio === '2') {
          data.so_id = 0
          data.st_id = parseInt(this.alarmRadio)
        }
      }
      hanlealarm(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功处理该警报',
          type: 'success',
          duration: 2000
        })
        let mqtts = this.$store.state.user.mqtts
        let name = this.$store.state.user.personname
        let dohandle = {id: this.alarmid, name: name}
        sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
        this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
          if (this.$route.path === '/handleAlarm') {
            this.golobleObject.updateTableAlarm()
          }
        })
        let obj = {type: 'close'}
        this.$emit('getFatherHandle', obj)
      }).catch(() => {})
    },
    // 服务派单
    handleServiceCommit () {
      console.log(33, this.serviceObj.oldperson)
      let obj = {
        oldPerson: this.serviceObj.oldperson
      }
      this.store2.dispatch('other/update_handle_service', obj).then(() => {
        this.$router.push('/serviceSupplierOrder')
      })
      this.closeWindow()
    },
    openMapLocation () {
      this.showLoaction = true
    }
  }
}
</script>

<style scoped>
  .handle-open{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    border-radius: 6px;
    font-size: 14px;
    color: #606266;
  }
  .span-color{
    color: #1a1a1a;
  }
  .span-font{
    color: #1684fc;
    font-size: 22px;
    font-family: letisgoDigital!important;
  }
  .history-handle{
    width: 110px;
    height: 26px;
    background-image: linear-gradient(0deg,
    #1684fc 0%,
    #66b2ff 100%);
    border-radius: 13px;
    font-size: 14px;
    color: white;
    float: left;
    margin-left: 5px;
    cursor: pointer;
    line-height: 26px;
    text-align: center;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #f5e287!important;
  }
  .send-btn-yellow{
    width: 160px;
    height: 30px;
    line-height: 30px;
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    background-image: linear-gradient(0deg,
    #f5e287 0%,
    #edc14e 30%,
    #e5a015 100%);
    box-shadow: 0px 2px 4px 0px
    #c48b19,
    inset 0px -2px 1px 0px
    rgba(255, 255, 255, 0.7);
    border-radius: 16px;
    float: left;
  }
  .send-btn-yellow1{
    cursor: pointer;
    width: 30px;
    height: 30px;
    line-height: 30px;
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    background-image: linear-gradient(0deg,
    #f5e287 0%,
    #edc14e 30%,
    #e5a015 100%);
    box-shadow: 0px 2px 4px 0px
    #c48b19,
    inset 0px -2px 1px 0px
    rgba(255, 255, 255, 0.7);
    border-radius: 10px;
    float: left;
    margin-left: 10px;
  }
  .list-csd{
    padding: 10px;
    overflow: hidden;
    z-index: 999999;
    position: relative;
    width: 360px;
    /*max-height: 168px;*/
    /*overflow-y: auto;*/
    top: 6px;
    left: 105px;
    border-radius: 10px;
    background-color: #f2ce61;
  }
  .left-level1{
    float: left;
    height: 168px;
    overflow-y: auto;
    width: 130px;
    /*border: 1px solid #c48b19;*/
  }
  .left-level2{
    float: left;
    height: 168px;
    overflow-y: auto;
    width: 230px;
    /*border: 1px solid #c48b19;*/
  }
  .level-line1{
    width: 130px;
    /*cursor: no-drop;*/
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    color: white;
    display:block;
    overflow:hidden;
    word-break:keep-all;
    white-space:nowrap;
    text-overflow:ellipsis;
    /*border-bottom: 1px solid #efad28;*/
    text-align: left;
  }
  .level-line1-active{
    width: 130px;
    /*cursor: no-drop;*/
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    color: #ffffff;
    display:block;
    overflow:hidden;
    word-break:keep-all;
    white-space:nowrap;
    text-overflow:ellipsis;
    /*border-bottom: 1px solid #efad28;*/
    text-align: left;
    background-color: #e5c35c;
  }
  .level-line1:hover{
    background-color: #e5c35c;
  }
  .list-csd-item{
    margin-left: 10px;
    cursor: pointer;
    font-size: 14px;
    text-align: left;
    height: 28px;
    line-height: 28px;
    background-color: #f2ce61;
    color: white;
    display:block;
    overflow:hidden;
    word-break:keep-all;
    white-space:nowrap;
    text-overflow:ellipsis;
  }
  .list-csd-item:hover{
    background-color: #e5c35c;
  }
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/doHandleAlarm.vue